import { Modal } from "antd";
import React from "react";
import CreatePrepGuideMainPage from "../orgAdmin/prepGuides/preparation/CreatePrepGuideMainPage";


function CreateJdModal({ openCreateJdModal, setOpenCreateJdModal,getAllJds }) {
  return (
    <Modal
      open={openCreateJdModal}
      onCancel={() => setOpenCreateJdModal(false)}
      title={<div className="text-xl">Create JD</div>}
      centered
      footer={null}
      width={1100}
    >
      <CreatePrepGuideMainPage
        setOpenCreateJdModal={setOpenCreateJdModal}
        backButtonHide={true}
        getAllJds={getAllJds}
      />
    </Modal>
  );
}

export default CreateJdModal;
